export const SOLSHARE_VERSION = {
  Mk1: 'Mk1',
  Mk2: 'Mk2',
} as const;

export const GENERATION = {
  ONE: 'gen1',
  TWO: 'gen2',
} as const;
